import React, { FunctionComponent } from 'react';

import { PlanLimits } from '@components/bulk_management/user-settings/PlanLimits';

export const UserSettings: FunctionComponent = () => (
  <PlanLimits />
);